/**
 * @author     Shivam Shrivastava
 * @date        Nov, 2024
 * @copyright   www.ibirdsservices.com
 */

import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import SparkApi from "../api/SparkApi";


const ResetPassword = () => {
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({ newPassword: "", confirmPassword: "" });
    const [passwordError, setPasswordError] = useState("");


    const location = useLocation();
    const email = location.pathname.split('/').pop();


    const handleSubmit = async (e) => {
        try {
            e.preventDefault();

            if (Object.keys(passwordError).length > 0) {
                return toast.error("Invalid password");
              }

            const result = await SparkApi.ResetPassword(email, credentials.newPassword)

            if (result.success) {

                toast.success(result.message);
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            }
            else {
                toast.error(result.message)
                setPasswordError()
                setTimeout(() => {
                    navigate('/forget-password');
                }, 2000);
            }
        } catch (error) {
            return toast.error(error)
        }
    };
    const handleChange = (e) => {
       // setCredentials({ ...credentials, [e.target.name]: e.target.value });
       if(e.target.name === "newPassword"){
        const trimmedValue = e.target.value.replace(/\s/g, ''); 
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        const isValidPassword = passwordRegex.test(trimmedValue);
        setCredentials({ ...credentials, [e.target.name]: trimmedValue});
        if (!isValidPassword) {
          setPasswordError("Password must be 8+ chars with A-Z, a-z, 0-9 & special char.");
        } else {
          setPasswordError("");
        }
        }else{
          setCredentials({ ...credentials, [e.target.name]: e.target.value });
        }

    };


    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <div className="w-40 justify-content-center">
                <div className="forget-form-content">
                    <div className="p-4 shadow-sm bg-white rounded">
                        <Form className="mt-2" onSubmit={handleSubmit}>

                            <div className="">
                                <h3 className="text-center ">
                                    {" "}
                                    <img src="/srmlogo.jpg" style={{ width: "120px" }} className="mb-2" alt="" />
                                    <div>Convert, before it fades away</div>
                                </h3>
                            </div>


                            <Form.Group
                                className="mb-3 mt-2"
                                controlId="formBasicusername"
                            >
                                <Row className="mt-3">
                                    <Col lg={12}>
                                        <Form.Label>Create New Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="newPassword"
                                            onChange={handleChange}
                                            placeholder="Enter New Password Password"
                                            value={credentials.newPassword}
                                        />
                                         {
                        passwordError ?
                          <span style={{  color: "#f62b2b",
                            fontWeight: "600",
                            paddingTop: "5px", }}>
                            {passwordError}
                          </span>
                        :''
                      }
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col lg={12}>
                                        <Form.Label>Confirm New Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="confirmPassword"
                                            onChange={handleChange}
                                            placeholder="Confirm New Password Password"
                                            value={credentials.confirmPassword}
                                        />
                                      <b
  className="mt-3"
  style={{
    color: credentials.newPassword === credentials.confirmPassword ? "#2bd965" : "#f62b2b",
    fontWeight: "600",
  }}
>
  { !passwordError && credentials.newPassword && credentials.confirmPassword
    ? credentials.newPassword === credentials.confirmPassword
      ? "Passwords match"
      : "Passwords do not match"
    : ""}
</b>
                                        <div className="mt-2">
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col lg={12}>
                                        <Button
                                            className="btn btn-lg w-100 submit"
                                            variant="primary"
                                            type="submit"
                                            disabled={!credentials.newPassword || passwordError || (credentials.newPassword !== credentials.confirmPassword)}                                        >
                                            Create
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <center className="mt-3">
                                <strong><Link to="/forget-password" style={{ textDecoration: 'none' }}>Go Back</Link></strong>
                            </center>
                        </Form>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1500} theme="light" />
        </Container>
    );
};
export default ResetPassword;